import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BasketBall, Football } from './theme';
import { DataService } from 'src/providers/data/data.service';
import { WebsocketService } from 'src/providers/WebsocketService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dashboard';
  dashboardParams: { sport: any, perpage: number, frequency: number }
  constructor(private activatedRoute: ActivatedRoute, private dataService: DataService, private websocketService: WebsocketService) {
    this.websocketService.connect();
    this.dashboardParams = { perpage: 10, sport: '1', frequency: 5 }
    this.activatedRoute.queryParams.subscribe(params => {
      this.dashboardParams.perpage = params['pp'] || this.dashboardParams.perpage;
      this.dashboardParams.sport = params['spt'] || this.dashboardParams.sport;
      this.dashboardParams.frequency = params['f'] || this.dashboardParams.frequency;
      this.initializeTheme(this.dashboardParams);
      this.initialiseGetData(this.dashboardParams);
    });


  }
  async initialiseGetData(params) {
    this.dataService.getDashBoardData(params).then(data => {
      console.log("resolving")

      this.dataService.data.forEach(match => {
        var date = new Date();
        this.websocketService.subscribe(match.tournamentId + '.*.' + `${date.getFullYear() + '' + (date.getMonth() + 1) + '' + (date.getDate() + "").padStart(2, '0')}`)
      })
    });

    this.dataService.getLatestResults(params);
  }
  initializeTheme(dashboardParams) {
    let selectedTheme = Football;

    switch (dashboardParams.sport) {
      case '1':
        this.dataService.activeSport = Football.name
        selectedTheme = Football;
        break;
      case '2':
        this.dataService.activeSport = BasketBall.name
        selectedTheme = BasketBall;
        break;
      default:
        break;

    }

    for (const property of Object.keys(selectedTheme.properties)) {
      document.documentElement.style.setProperty(property, selectedTheme.properties[property]);
    }
  }
}
